module.exports = __webpack_public_path__ + "static/media/rainy-sun.f134a51c.svg";